import { IconProps } from '@openeducation/oe-it-shared-types';
import * as React from 'react';
import { useTheme } from 'react-native-paper';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

export const NoConnectionIcon = ({
  fill,
  width = 35,
  height = 35,
}: IconProps) => {
  const { colors } = useTheme();

  return (
    <Svg width={width} height={height} viewBox="0 0 35 35" fill="none">
      <G clipPath="url(#clip0_32_6623)">
        <Path
          d="M30.25 16.083l2.833-2.833C27.8 7.966 20.517 5.954 13.675 7.144L17.33 10.8c4.675-.028 9.364 1.729 12.92 5.284zm-2.834 2.834a14.018 14.018 0 00-5.27-3.301l4.279 4.278.991-.977zM13.25 24.583l4.25 4.25 4.25-4.25c-2.338-2.351-6.149-2.351-8.5 0zM5.33 2.823L3.334 4.821l4.321 4.32a22.244 22.244 0 00-5.737 4.109l2.833 2.833a17.918 17.918 0 015.907-3.938l3.174 3.173a13.916 13.916 0 00-6.248 3.599l2.833 2.833a9.914 9.914 0 016.928-2.918l10.03 10.03 1.998-1.998L5.33 2.824z"
          fill={fill ?? colors.error}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_32_6623">
          <Path fill="#fff" transform="translate(.5 .5)" d="M0 0H34V34H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
